import { type FC, type ReactNode } from 'react'

import * as styles from './styles'

const DefaultAutocompleteWrapper: FC<{ children: ReactNode }> = ({ children }) => (
  <div css={styles.autocompleteContainer}>{children}</div>
)

export default DefaultAutocompleteWrapper
